module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytic-unit-block-loader"
  }, [_c('content-loader', {
    attrs: {
      "height": 300,
      "width": 500,
      "speed": 2,
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "33",
      "y": "18.61",
      "rx": "3",
      "ry": "3",
      "width": "391.85",
      "height": "24.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "34",
      "y": "54.4",
      "rx": "3",
      "ry": "3",
      "width": "430.5",
      "height": "7.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32",
      "y": "81",
      "rx": "3",
      "ry": "3",
      "width": "56.28",
      "height": "59.64"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "459.68",
      "cy": "32.7",
      "r": "11.7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "107.56",
      "y": "79.61",
      "rx": "0",
      "ry": "0",
      "width": "364",
      "height": "22"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "414.56",
      "y": "85.61",
      "rx": "0",
      "ry": "0",
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "107.56",
      "y": "118.61",
      "rx": "0",
      "ry": "0",
      "width": "364",
      "height": "22"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "32.56",
      "y": "190",
      "rx": "0",
      "ry": "0",
      "width": "435",
      "height": "93"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9303766a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/content-loaders/AnalyticsUnitBlockLoader.vue
// module id = 3370
// module chunks = 3